import { Controller } from "@hotwired/stimulus"

// Toggles the kind-specific fields of the report definition form:
// blazer_sql -> Blazer query id, job -> run_class generator.
export default class extends Controller {
  static targets = ["kind", "blazerFields", "jobFields"]

  connect() {
    this.toggle()
  }

  toggle() {
    const isJob = this.kindTarget.value === "job"
    this.blazerFieldsTarget.hidden = isJob
    this.jobFieldsTarget.hidden = !isJob
  }
}
